import MediaCard from "@/components/feature/MediaCard";
import SectionHeading from "@/components/feature/SectionHeading";
import type { MediaItem } from "@/types/media";

export default function NewSection({ items }: { items: MediaItem[] }) {
  const list = [...items].sort((a, b) => b.year - a.year || b.views - a.views).slice(0, 10);

  return (
    <div>
      <SectionHeading
        title="新上映影视"
        subtitle="按上映时间倒序，第一时间看新剧热片"
        moreTo="/category/movie"
        moreLabel="更多新片"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
        {list.map((item) => (
          <MediaCard key={item.id} item={item} showPlay />
        ))}
      </div>
    </div>
  );
}